<template>
  <div class="auth-page">
      <div class="container container-height">
          <div class="row">
              <div class="col-md-5 mx-auto">
                  <form>
                      <div class="logincontainer-shadow mt-5 p-4">
                          <div class="row pb-3">
                              <div class="col-md-12 text-center">
                                  <img v-bind:src="cdnUrl" class="form-group" width="180" />

                                  <h2>Merchant Login</h2>
                              </div>
                          </div>
                          <div class="form-group">
                              <div class="input-group">
                                  <div class="input-group-prepend">
                                      <span class="input-group-text" id="basic-addon1">+91</span>
                                  </div>
                                  <input autocomplete="off" type="text" v-model="loginForm.mobileNo" class="form-control" :class="{ 'is-invalid': submitted && v$.loginForm.mobileNo.$error }" placeholder="Mobile No." />
                                  <!-- <div v-if="submitted && !v$.loginForm.mobileNo.required" class="invalid-feedback">Mobile No. is required</div>
                                <div v-if="submitted && !v$.loginForm.mobileNo.minLength" class="invalid-feedback">Invalid Mobile No. format</div> -->
                                  <div v-for="error of v$.loginForm.mobileNo.$errors" :key="error.$uid" class="invalid-feedback">
                                      {{ error.$message }}
                                  </div>
                              </div>
                          </div>
                          <div class="form-group has-icon">
                              <input type="password" v-model="loginForm.password" autocomplete="off" class="form-control" :class="{ 'is-invalid': submitted && v$.loginForm.password.$error }" placeholder="Password" />
                              <span class="icon-lock-closed form-control-feedback"></span>
                              <!-- <div v-if="submitted && !v$.loginForm.password.required" class="invalid-feedback">Password is required</div> -->
                              <div v-for="error of v$.loginForm.password.$errors" :key="error.$uid" class="invalid-feedback">
                                  {{ error.$message }}
                              </div>
                          </div>

                         <!-- <div class="form-group">
                            <label for="input-datalist">Timezone</label>
                            <input type="text" class="form-control" placeholder="Timezone" list="list-timezone" id="upiCus" ref="upiCus">
                            <datalist id="list-timezone">
                                <option>Asia/Aden</option>
                                <option>Asia/Aqtau</option>
                                <option>Asia/Baghdad</option>
                                <option>Asia/Barnaul</option>
                                <option>Asia/Chita</option>
                                <option>Asia/Dhaka</option>
                                <option>Asia/Famagusta</option>
                                <option>Asia/Hong_Kong</option>
                                <option>Asia/Jayapura</option>
                                <option>Asia/Kuala_Lumpur</option>
                                <option>Asia/Jakarta</option>
                            </datalist>
                        </div> -->
                          <!-- <div class="form-group">
             <vue-recaptcha ref="recaptcha" :sitekey="siteKey"
            @verify="onVerify"  @expired="onExpired"
            />
            <div v-if="submitted && !recaptcha" class="invalid-feedback d-block">
              Please Verify captcha
            </div> 
            &nbsp;
          </div>-->
                          <input type="hidden" v-model="loginForm._csrf" />
                          <!-- <button  class="btn btn-success btn-lg btn-block">
                            Login
                </button>   <br/> -->
                          <invisible-recaptcha class="btn btn-success btn-lg btn-block" ref="InvisibleRecaptcha" :sitekey="siteKey" :callback="onSubmit">
                              Login
                          </invisible-recaptcha>
                          <br />
                          <p class="text-small text-center">By clicking Login, you agree to our <a style="text-decoration: underline;" href="https://www.paysharp.in/merchant-terms" target="_blant">merchant terms</a></p>
                      </div>
                  </form>
              </div>
          </div>
      </div>
  </div>
</template>

<script>

  import useVuelidate from "@vuelidate/core";
  import { required, minLength, maxLength, helpers } from "@vuelidate/validators";
  import InvisibleRecaptcha from "vue-invisible-recaptcha";
  export default {
      name: "login",
      components: { "invisible-recaptcha": InvisibleRecaptcha },
     
      data() {
          return {
              v$: useVuelidate(),
              cdnUrl: process.env.VUE_APP_CDN_URL + "/img/paysharp.png",
              loginForm: {
                  mobileNo: "",
                  password: "",
                  _csrf: "",
              },
              submitted: false,
              recaptcha: null,
              siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
          };
      },
      validations() {
          return {
              loginForm: {
                  mobileNo: { required: helpers.withMessage("Mobile No. is required", required), minLength: helpers.withMessage("Invalid Mobile No. format", minLength(10)), maxLength: maxLength },
                  password: { required: helpers.withMessage("Password is required", required) },
              },
          };
      },
      methods: {
          async onSubmit(recaptchaToken) {
              try {
                  this.submitted = true;
                  this.v$.$touch();
                  if (this.v$.$invalid) {
                      return false;
                  } else {
                      if (!recaptchaToken) {
                          return false;
                      }
                      await this.$store.dispatch("user/initCsrfToken");
                      this.loginForm._csrf = this.$store.state.user.csrfToken;
                      await this.$store.dispatch("user/login", this.loginForm);

                      if (this.$store.state.user.loginTypeId == 1) {
                          this.$router.push("/dashboard");
                      } else if (this.$store.state.user.loginTypeId == 2) {
                          this.$router.push("/verify");
                      }
                  }
              } catch (err) {}
          },
          // onVerify(response)
          // {
          //   this.recaptcha = response;
          // },
          // onExpired()
          // {
          //   this.$refs.recaptcha.reset();
          // }
      },
  };
</script>
